const Tag = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 22 22" fill="none">
      <path
        d="M4.53501 14.0022L8.3909 17.8581C9.97412 19.4413 12.5447 19.4413 14.1364 17.8581L17.8732 14.1213C19.4564 12.5381 19.4564 9.96753 17.8732 8.3758L14.0088 4.52842C13.2001 3.71979 12.0851 3.28568 10.9445 3.34526L6.68852 3.54955C4.98614 3.62616 3.63275 4.97955 3.54763 6.67342L3.34334 10.9294C3.29227 12.0785 3.72638 13.1935 4.53501 14.0022Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.07155 11.1935C10.2468 11.1935 11.1995 10.2407 11.1995 9.06548C11.1995 7.89023 10.2468 6.9375 9.07155 6.9375C7.8963 6.9375 6.94357 7.89023 6.94357 9.06548C6.94357 10.2407 7.8963 11.1935 9.07155 11.1935Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M12.0507 15.4497L15.4555 12.0449"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Tag;
